import { render, staticRenderFns } from "./Resolve.vue?vue&type=template&id=32f68f9e"
import script from "./Resolve.vue?vue&type=script&lang=js"
export * from "./Resolve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports